(function () {
  'use strict';

  document.addEventListener('variants:change', function (event) {
    const section = event.target.closest('.shopify-section');
    if (!section) return;

    const row = section.querySelector('[data-ean-row]');
    const value = section.querySelector('[data-ean-value]');
    const data = section.querySelector('[data-variant-barcodes]');
    if (!row || !value || !data) return;

    try {
      const barcodes = JSON.parse(data.textContent);
      const variant = event.detail && event.detail.variant;
      const barcode = variant ? String(barcodes[variant.id] || '').trim() : '';
      value.textContent = barcode;
      row.style.display = barcode ? '' : 'none';
    } catch (error) {
      console.warn('Could not parse variant barcodes:', error);
    }
  }, true);
})();
